import {
  CommunicationBasics,
  EntertainmentAndLeisure,
  FeelingsAndEmotions,
  FoodAndDining,
  HealthAndWellBeing,
  MainCategories,
  NubmersAndQuantity,
  SocialContexts,
  TimeAndDates,
  TravelAndDirections
} from '@shared/openapi/jaaluu-api';

export const CATEGORIES_ZH = {
  [MainCategories.COMMUNICATION_BASICS]: {
    title: '交流',
    categories: {
      [CommunicationBasics.GREETINGS]: '问候',
      [CommunicationBasics.QUESTIONS]: '问题',
      [CommunicationBasics.EXPRESSIONS]: '表达'
    }
  },
  [MainCategories.FEELINGS_AND_EMOTIONS]: {
    title: '感情和情绪',
    categories: {
      [FeelingsAndEmotions.POSITIVE_EMOTIONS]: '积极情绪',
      [FeelingsAndEmotions.NEGATIVE_EMOTIONS]: '消极情绪',
      [FeelingsAndEmotions.NEUTRAL_OR_MIXED_FEELINGS]: '中性或混合情绪'
    }
  },
  [MainCategories.TRAVEL_AND_DIRECTIONS]: {
    title: '旅行和方向',
    categories: {
      [TravelAndDirections.DIRECTIONS]: '方向',
      [TravelAndDirections.LOCATIONS]: '地点',
      [TravelAndDirections.TRANSPORTATION]: '交通',
      [TravelAndDirections.ACCOMODATION]: '住宿'
    }
  },
  [MainCategories.NUMBERS_AND_QUANTITY]: {
    title: '数字和数量',
    categories: {
      [NubmersAndQuantity.NUMBERS]: '数字',
      [NubmersAndQuantity.QUANTITY]: '数量'
    }
  },
  [MainCategories.TIME_AND_DATES]: {
    title: '时间和日期',
    categories: {
      [TimeAndDates.TIME]: '时间',
      [TimeAndDates.DATES]: '日期'
    }
  },
  [MainCategories.ENTERTAINMENT_AND_LEISURE]: {
    title: '娱乐和休闲',
    categories: {
      [EntertainmentAndLeisure.ENTERTAINMENT]: '娱乐',
      [EntertainmentAndLeisure.LEISURE]: '休闲'
    }
  },
  [MainCategories.HEALTH_AND_WELL_BEING]: {
    title: '健康和福祉',
    categories: {
      [HealthAndWellBeing.HEALTH]: '健康',
      [HealthAndWellBeing.WELL_BEING]: '福祉'
    }
  },
  [MainCategories.SOCIAL_CONTEXTS]: {
    title: '社会背景',
    categories: {
      [SocialContexts.SOCIAL]: '社会',
      [SocialContexts.CULTURAL]: '文化',
      [SocialContexts.RELIGIOUS]: '宗教',
      [SocialContexts.POLITICAL]: '政治'
    }
  },
  [MainCategories.FOOD_AND_DINING]: {
    title: '食物和餐饮',
    categories: {
      [FoodAndDining.FOOD]: '食物',
      [FoodAndDining.DRINKS]: '饮料',
      [FoodAndDining.DINING]: '用餐'
    }
  }
};
